module.exports = __webpack_public_path__ + "media/images/symbols/play-button-ba253fa9824186953046e6b847d85008.svg";